// import here your js
import './libs/fancybox.js';
import './libs/animations.js';
//import './libs/quicklink.js';


// import local dependencies
import Router from '../../scripts/util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./_project/scripts/project.js